var StatusIndicatorMode;
(function (StatusIndicatorMode) {
    StatusIndicatorMode["DRAFT_WAYPOINT"] = "draftWaypoint";
    StatusIndicatorMode["EXACT"] = "exact";
    StatusIndicatorMode["GENERIC"] = "generic";
    StatusIndicatorMode["PROCEDURE"] = "procedure";
})(StatusIndicatorMode || (StatusIndicatorMode = {}));
var StatusIndicatorSize;
(function (StatusIndicatorSize) {
    StatusIndicatorSize["XS"] = "xs";
    StatusIndicatorSize["SM"] = "sm";
    StatusIndicatorSize["MD"] = "md";
    StatusIndicatorSize["LG"] = "lg";
})(StatusIndicatorSize || (StatusIndicatorSize = {}));

export { StatusIndicatorMode, StatusIndicatorSize };
